import { writable } from "svelte/store";
const KEY = "piq.sidebar.collapsed";
function load() {
    if (typeof localStorage === "undefined")
        return false;
    try {
        return localStorage.getItem(KEY) === "1";
    }
    catch (_a) {
        return false;
    }
}
export const sidebarCollapsed = writable(load());
sidebarCollapsed.subscribe((v) => {
    if (typeof localStorage === "undefined")
        return;
    try {
        localStorage.setItem(KEY, v ? "1" : "0");
    }
    catch (_a) { }
});
export function toggleSidebar() {
    sidebarCollapsed.update((v) => !v);
}
